export default __webpack_public_path__ + "6d970c3d10378db6b96ceca846aca9b1.png";